/* eslint-disable */
import Slider from '../components/Slider';

export default {
    sliderInit() {
		const slider = new Slider;
		slider.init();
	},

    init() {
		this.sliderInit();
    },
    
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js